// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  position: relative;
  justify-content: center;
  width: 100%;
  overflow: hidden;
}

.carousel-inner {
  display: flex;
  transition: transform 0.5s ease-in-out;
  margin-left: 3%;
}

.carousel-item {
  min-width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 0px 10px;
}

.carousel-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 1;
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}

.sec6-prt2-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #0B63E5;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  justify-content: space-between;
}

hr {
  border: 2px solid;
}

@media (max-width: 500px) {
  .sec6-prt2-cont>ul>li {
    line-height: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Carousel.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".carousel {\r\n  position: relative;\r\n  justify-content: center;\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-inner {\r\n  display: flex;\r\n  transition: transform 0.5s ease-in-out;\r\n  margin-left: 3%;\r\n}\r\n\r\n.carousel-item {\r\n  min-width: 100%;\r\n  box-sizing: border-box;\r\n  padding: 20px 20px 0px 10px;\r\n}\r\n\r\n.carousel-button {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  color: white;\r\n  border: none;\r\n  padding: 10px;\r\n  cursor: pointer;\r\n  z-index: 1;\r\n}\r\n\r\n.prev {\r\n  left: 10px;\r\n}\r\n\r\n.next {\r\n  right: 10px;\r\n}\r\n\r\n.sec6-prt2-cont {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  text-align: center;\r\n  background-color: #0B63E5;\r\n  padding: 20px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  justify-content: space-between;\r\n}\r\n\r\nhr {\r\n  border: 2px solid;\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .sec6-prt2-cont>ul>li {\r\n    line-height: 20px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
